'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactCopyToClipboard = require('react-copy-to-clipboard');


var _components = require('../../components');




var _CopyClipboardInput = require('./CopyClipboardInput.scss');var styles = _interopRequireWildcard(_CopyClipboardInput);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Styles
var CopyClipboardInput = function (_Component) {_inherits(CopyClipboardInput, _Component);function CopyClipboardInput() {var _temp, _this, _ret;_classCallCheck(this, CopyClipboardInput);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      copied: false }, _this.


    handleCopyLink = function () {
      if (!_this.props.clipText) return;
      _this.setState({
        copied: true });

    }, _temp), _possibleConstructorReturn(_this, _ret);}CopyClipboardInput.prototype.

  render = function render() {var _props =
    this.props,translate = _props.translate,clipText = _props.clipText,isRtl = _props.isRtl,isMobile = _props.isMobile;

    return (
      _react2.default.createElement('div', { className: styles.referralSection },
        _react2.default.createElement('span', null, translate('editProfile', 'referralLink')),
        _react2.default.createElement('div', { className: styles.input },
          _react2.default.createElement(_components.OMInputField, {
            initialValue: clipText,
            name: 'referral',
            isRtl: isRtl,
            disabled: true,
            type: 'text',
            isMobile: isMobile }),

          _react2.default.createElement(_reactCopyToClipboard.CopyToClipboard, {
              text: clipText,
              onCopy: this.handleCopyLink },

            _react2.default.createElement('div', { className: styles.copy },
              this.state.copied ?
              translate('editProfile', 'copied') :
              translate('editProfile', 'copy'))))));





  };return CopyClipboardInput;}(_react.Component);


CopyClipboardInput.propTypes = {
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  clipText: _propTypes2.default.string.isRequired };exports.default =


CopyClipboardInput;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CopyClipboardInput/CopyClipboardInput.js
// module id = 2642
// module chunks = 0